import { useMediaQuery } from "@/hooks/useMedia";
import { setLocale } from "@/paraglide/runtime";
// import { Locale, setLocale } from "@/paraglide/runtime";
// import { useLocation } from "@tanstack/react-router";
import { Fragment, useState } from "react";
import { TransIcon } from "../icons/header";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import {
	HoverCard,
	HoverCardContent,
	HoverCardTrigger,
} from "../ui/hover-card";
import { Separator } from "../ui/separator";

const languages = [
	{ code: "en", name: "English" },
	{ code: "id", name: "Bahasa Indonesia" },
	{ code: "de", name: "Deutsch" },
	{ code: "fr", name: "Français" },
	{ code: "es", name: "Español" },
	{ code: "ru", name: "Русский" },
];

if (import.meta.env.DEV) {
	languages.unshift({ code: "zh", name: "中文简体" });
}

const i18nChannel = new BroadcastChannel("i18n_channel");
i18nChannel.onmessage = (event) => {
	setLocale(event.data);
};

export function LanguageSelector() {
	const isMobile = useMediaQuery("(max-width: 768px)");
	const [isOpen, setIsOpen] = useState(false);

	const handleLanguageChange = (langCode: string) => {
		if (
			langCode !== localStorage.getItem("PARAGLIDE_LOCALE") ||
			!location.pathname.includes(`/${langCode}`)
		) {
			localStorage.setItem("PARAGLIDE_LOCALE", langCode);
			window.location.href = `/${langCode}`;
			i18nChannel.postMessage(langCode);
		}
	};

	const LanguageContent = () => (
		<>
			{languages.map((lang, idx) => (
				<Fragment key={lang.code}>
					<div
						className="h-8 cursor-pointer flex items-center px-2 text-t2 gap-2 m-1 rounded-[6px] hover:bg-c1"
						onClick={() => handleLanguageChange(lang.code)}
					>
						{lang.name}
					</div>
					{idx < languages.length - 1 && <Separator className="h-10.5" />}
				</Fragment>
			))}
		</>
	);

	// 移动端使用 DropdownMenu
	if (isMobile) {
		return (
			<DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
				<DropdownMenuTrigger asChild>
					<div className="icon-wrapper !w-fit">
						<TransIcon className="icon-wrapper" />
					</div>
				</DropdownMenuTrigger>
				<DropdownMenuContent className="w-46 py-1 mt-3">
					{languages.map((lang, idx) => (
						<Fragment key={lang.code}>
							<DropdownMenuItem
								className="h-8 cursor-pointer flex items-center px-2 text-t2 gap-2 m-1 rounded-[6px] hover:bg-c1"
								onClick={() => handleLanguageChange(lang.code)}
							>
								{lang.name}
							</DropdownMenuItem>
							{idx < languages.length - 1 && <Separator className="h-10.5" />}
						</Fragment>
					))}
				</DropdownMenuContent>
			</DropdownMenu>
		);
	}

	// PC 端使用 HoverCard
	return (
		<HoverCard>
			<HoverCardTrigger asChild>
				<div className="icon-wrapper !w-fit">
					<TransIcon className="icon-wrapper" />
				</div>
			</HoverCardTrigger>
			<HoverCardContent className="w-48 py-1 mt-3">
				<LanguageContent />
			</HoverCardContent>
		</HoverCard>
	);
}
